import { Component, OnInit } from '@angular/core';
import { CargaAbonosService } from 'src/app/services/carga-abonos/carga-abonos.service';
import { PostulacionesService } from 'src/app/services/postulaciones/postulaciones.service';
import { AfiliacionService } from 'src/app/services/afiliacion/afiliacion.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { isNullOrUndefined } from 'util';
import { environment } from '../../../environments/environment';
import { FormsModule } from '@angular/forms';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import Swal from 'sweetalert2';

export interface DialogData {
    tipoCarga: any
    recarga: boolean
}

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';


@Component({
    selector: 'app-carga-cuotas',
    templateUrl: '../../pages/afiliacion/carga-cuotas/carga-cuotas.component.html',
    styleUrls: ['../../pages/afiliacion/carga-cuotas/carga-cuotas.component.css']
})
export class CargaCuotasComponent implements OnInit {
    rol: string = localStorage.getItem("rol")
    idUsuario: string = localStorage.getItem("idUsuario")
    nombreUsuario: string = localStorage.getItem("nombreUsuario")
    config: any = { itemsPerPage: 10, currentPage: 1, totalItems: 0, indexInicial: 0, indexMaximo: 10 }
    cargaMasiva: any = { tipoCarga: null, idUsuario: null, archivo: File = null, }
    fechaExtraccion: any
    fechaEnvio: any    
    currentDate: any
    botonActivo: any = true
    allComplete: boolean = false

    constructor(private CargaAbonosService: CargaAbonosService,
        private afiliacionService: AfiliacionService,
        private postulacionesService: PostulacionesService,
        private dialog: MatDialog) { }

    ngOnInit(): void {
        let vm = this
        this.currentDate = new Date(Date.now()).getTime();


        this.loadData()
    }

    loadData() {
        let vm = this
    }


    verArchivo(postulacionId: any) {
        let vm = this

        this.postulacionesService.traeArchivos(postulacionId).then
            (
                (archivos: any) => {
                    archivos.forEach(archivo => {
                        var fileURL = `${environment.urlBlob}/${archivo.url}`
                        window.open(fileURL);
                    })

                }
            )
            .catch
            (
                error => {
                    console.log(error)

                    vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')
                }
            )
    }


    csvInputChange(fileInputEvent: any) {

        this.cargaMasiva.archivo = fileInputEvent.target.files[0]
    }

    enviarPostulacionesSeleccionadas() {
        let vm = this
        this.botonActivo = false;
        if (isNullOrUndefined(this.cargaMasiva.archivo) ||
            this.cargaMasiva.archivo?.type != ('text/csv')) {
            this.openAlertDialog('Debe seleccionar un archivo CSV.', 'btn-danger')
            this.botonActivo = true;
            return
        }
        this.CargaAbonosService.creaCargaAfiliados(this.cargaMasiva, this.idUsuario).then
            (
                () => {
                    vm.openAlertDialog('El proceso de carga abonos se está realizando, cuando finalice se le enviará un correo notificando.', 'btn-success')
                    this.cargaMasiva.archivo = null;
                    this.botonActivo = true;
                }
            )
            .catch(error => {
                console.log(error)

                vm.openAlertDialog('Ha ocurrido un error al procesar la carga', 'btn-danger')
                this.cargaMasiva.archivo = null;
                this.botonActivo = true;
            })
    }


    openAlertDialog(mensaje: string, clase: string) {
        const dialogRef = this.dialog.open(AlertDialogComponent,
            {
                data:
                {
                    message: mensaje,
                    clase: clase,
                    buttonText: { cancel: 'Listo!' },
                }
            })
    }

    pageChanged(event: any) {
        this.config.currentPage = event

        this.config.indexInicial = ((this.config.currentPage - 1) * this.config.itemsPerPage)
        this.config.indexMaximo = (this.config.currentPage * this.config.itemsPerPage)
    }



    excelCargaCuota() {
        var vm = this
        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });
        Swal.showLoading();
        let fechaExtraccionTemp = ''

        if (vm.fechaExtraccion) {
            fechaExtraccionTemp = vm.fechaExtraccion.split('-')[2] + '-' + vm.fechaExtraccion.split('-')[1] + '-' +
                vm.fechaExtraccion.split('-')[0]
        } else {
            vm.openAlertDialog('El campo fecha de Extracción no debe ir vacio', 'btn-danger')
            Swal.close();
            return false;
        }

        this.afiliacionService.retornaExcelCargaAfiliados(fechaExtraccionTemp).then
            (
                (data: any) => {
                    this.afiliacionService.getFileNameUrl(data.message).then
                        (
                            (archivos: any) => {
                                var fileURL = archivos.url
                                window.open(fileURL);
                                Swal.close();
                            }
                        )
                        .catch
                        (
                            (error) => {
                                console.log(error)
                                vm.openAlertDialog('Ha ocurrido un error para generar el archivo.', 'btn-danger')
                            }
                        )

                }
            )
            .catch
            (
                (error) => {
                    console.log(error)
                    vm.openAlertDialog('Ha ocurrido un error para generar el archivo.', 'btn-danger')
                }
            )

    }

    
    enviarTXaPS() {
        var vm = this
        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });
        Swal.showLoading();
        let fechaEnvioTemp = ''

        if (vm.fechaEnvio) {
            fechaEnvioTemp = vm.fechaEnvio.split('-')[2] + '-' + vm.fechaEnvio.split('-')[1] + '-' +
                vm.fechaEnvio.split('-')[0]
        } else {
            vm.openAlertDialog('El campo fecha de envío no debe ir vacio', 'btn-danger')
            Swal.close();
            return false;
        }

        this.afiliacionService.enviarTXaPS(fechaEnvioTemp).then
            (
                (data: any) => {
                    console.log('data:',data)
                    if(data.id=='respuesta ok'){
                        vm.openAlertDialog('el TX fue enviado correctamente a PS', 'btn-success')
                        Swal.close();
                    }else{
                        vm.openAlertDialog('La fecha de envío no corresponde', 'btn-danger')
                        Swal.close();
                    }
                }
            )
            .catch
            (
                (error) => {
                    vm.openAlertDialog('El envío a PS ha respondido un error', 'btn-danger')
                    Swal.close();
                }
            )

    }



}